import { TpAssetInfo, TpAssetRelationInfo } from './interfaces';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { useNavigate } from 'react-router';
import { VIEW_STATE_QUERY_PARAM } from '../snapshot/dashboardStateSerialization';
import {
  TpQueriedAssetsData,
  addOpenedAsset,
  selectQueriedAssets,
  setAssetLastSearchQuery,
} from './queriedAssetsSlice';

export function getAssetInfo(assetId: string, queriedAssetsData: TpQueriedAssetsData): TpAssetInfo | null {
  // NOTE: @todo this is a mockup function, in final version this must come from server!
  const queriedAssets = queriedAssetsData.queriedAssets;
  for (const asset of queriedAssets) if (asset.id == assetId) return asset;
  return null;
}

// @todo: remove all these hard-wired stuff, and get it from the served ontologies

export function getAssetTypeName(assetOntology: any, plural?: boolean) {
  if (!assetOntology) return '<Unknown>';
  if (plural) {
    return assetOntology.displayNamePlural;
  }
  return assetOntology.displayName;
}

const defaultAssetTypeIcon = 'flask-vial';

export function getAssetTypeIcon(assetOntology: any): any {
  if (!assetOntology?.icon) return defaultAssetTypeIcon;
  // Icons have following format: "icon-collection:icon-name" e.g. fa:vial
  const assetIcon = assetOntology.icon.split(':');
  // currently we only have font-awesome icons, this can be extended in the future
  if (assetIcon[0] === 'fa') return assetIcon[1];
  if (assetIcon[0] === 'fad') return assetOntology.icon;
  if (assetIcon[0] === 'fas') return assetOntology.icon;
  return defaultAssetTypeIcon;
}

export function getRelationTypeName(relationOntology: any, reverse?: boolean): string {
  if (relationOntology) {
    if (reverse) return relationOntology.displayNameReverse;
    else return relationOntology.displayNameForward;
  }
  return 'is related to';
}

export function assetCached(assetId: string, queriedAssetsData: TpQueriedAssetsData) {
  return queriedAssetsData.queriedAssets.filter((asset) => asset.id == assetId).length > 0;
}

export function getAssetRelations(assetId: string, queriedAssetsData: TpQueriedAssetsData): TpAssetRelationInfo[] {
  const results: TpAssetRelationInfo[] = [];
  for (const asset of queriedAssetsData.queriedAssets) {
    if (asset.id == assetId) {
      for (const rel of asset.relations) {
        const destAsset = getAssetInfo(rel.to, queriedAssetsData);
        results.push({
          type: rel.type,
          isReverse: true,
          fromId: assetId,
          toAsset: destAsset!,
          id: rel.id,
        });
      }
    } else {
      for (const rel of asset.relations)
        if (rel.to == assetId) {
          results.push({
            type: rel.type,
            isReverse: false,
            fromId: assetId,
            toAsset: asset,
            id: rel.id,
          });
        }
    }
  }
  return results;
}

export function getFetchedAssetsByType(queriedAssetsData: TpQueriedAssetsData, assetType: string): TpAssetInfo[] {
  return queriedAssetsData.fetchedAssets.filter((asset) => asset.type == assetType);
}

export function getRelationTypeforAssets(ontology: any, fromAssetType: string, toAssetType: string): string | null {
  const fromAssetRelations = ontology.assetTypes[fromAssetType].relations;
  for (const rel of fromAssetRelations) if (rel.toAsset == toAssetType) return rel.identifier;
  return null;
}

export function useOpenAsset() {
  const dispatch = useAppDispatch();
  const queriedAssetsData = useAppSelector(selectQueriedAssets);
  const navigate = useNavigate();

  return function openAsset(assetId: string, viewState?: string) {
    const searchParams = new URLSearchParams(queriedAssetsData.lastSearchQuery[assetId] || '');
    if (viewState !== undefined) {
      if (viewState) searchParams.set(VIEW_STATE_QUERY_PARAM, viewState);
      else searchParams.delete(VIEW_STATE_QUERY_PARAM);
    }
    const query = searchParams.toString() ? `?${searchParams.toString()}` : '';

    dispatch(addOpenedAsset({ assetId }));
    dispatch(setAssetLastSearchQuery({ assetId, query }));
    navigate(`/asset/${assetId}${query}`);
  };
}
